import { Component, HostBinding, Input, OnInit } from '@angular/core'
import { getTaskStatusColor, getTaskStatusLabel, TaskStatus, TaskView } from '@tokeet-frontend/tasks'

@Component({
  selector: 'app-task-status',
  templateUrl: './task-status.component.html',
})
export class TaskStatusComponent implements OnInit {
  @Input() task: TaskView
  @Input() badge = true

  @HostBinding('class') get hostClasses() {
    if (!this.badge) return ''
    const color = getTaskStatusColor(this.task?.status)
    return `badge badge-secondary-${color}`
  }

  constructor() {}

  ngOnInit(): void {}

  getStatus(status: TaskStatus): string {
    return getTaskStatusLabel(status)
  }
}
